import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { grey, lightBlue, red, yellow } from '@mui/material/colors';
import ReactComponent from '@/components/ReactComponent';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';

const ESPACAMENTO_ENTRE_INFORMACOES = '5px';
const COR_TITULO_INFORMACOES_PROCESSO = lightBlue[900];

class Indicadores extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    corChipIndicador(corEtiqueta) {
        if (corEtiqueta === 'Laranja' || corEtiqueta === 'LARANJA') {
            return 'darkorange';
        } else if (corEtiqueta === 'Amarelo' || corEtiqueta === 'AMARELO') {
            return yellow[600];
        } else if (corEtiqueta === 'Vermelho' || corEtiqueta === 'VERMELHO') {
            return red[400];
        } else {
            return grey[400];
        }
    }

    get indicadores() {
        return this.registro.processo?.indicadores;
    }

    render() {
        return (
            <Box sx={{ mb: ESPACAMENTO_ENTRE_INFORMACOES, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <Typography
                    display="inline"
                    color={COR_TITULO_INFORMACOES_PROCESSO}
                    sx={{ fontWeight: 'bold', pt: 0.5 }}
                >
                    Indicadores:&nbsp;
                </Typography>
                {this.indicadores && this.indicadores.length > 0 ? (
                    this.indicadores.map((indicador) => {
                        return (
                            <Tooltip
                                key={indicador.codigo}
                                title={<Typography>Código {indicador.codigo}</Typography>}
                                placement="top"
                            >
                                <Chip
                                    label={indicador.descricao}
                                    style={{
                                        minWidth: '10ch',
                                        height: '24px',
                                        color: 'white',
                                        marginLeft: '10px',
                                        marginTop: ESPACAMENTO_ENTRE_INFORMACOES,
                                        backgroundColor: this.corChipIndicador(indicador.cor)
                                    }}
                                />
                            </Tooltip>
                        );
                    })
                ) : (
                    <Typography display="inline">Não há indicadores</Typography>
                )}
            </Box>
        );
    }
}

export default inject('stores')(observer(Indicadores));
